import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { AppState } from "@app/app.reducer";
import { select, Store } from "@ngrx/store";
import { map, Observable, Subject } from "rxjs";
import { ROLE_ADMIN } from "@app/shared/utils/roles";
import { Kpi } from "@app/kpi/models/kpi";
import * as fromKpi from "../../../ngrx/kpi.reducer";
import { KpiUtilsService } from "@app/kpi/services/kpi-utils.service";
import { Router } from "@angular/router";
import { KpiDetails } from "@app/kpi/models/kpi-details";

@Component({
  selector: "kpi-office-advanced",
  templateUrl: "./kpi-office-advanced.component.html",
  styleUrls: [
    "../../kpi-external.component.scss",
    "./kpi-office-advanced.component.scss",
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KpiOfficeAdvancedComponent implements OnInit, OnDestroy {
  @Input() params: Record<string, string>;

  employees$: Observable<KpiDetails[]>;
  summary$: Observable<Kpi>;
  role = ROLE_ADMIN;
  unsubscribe$ = new Subject<void>();

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private kpiUtils: KpiUtilsService
  ) {}

  ngOnInit(): void {
    this.mapStateToProps();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  mapStateToProps(): void {
    this.employees$ = this.store.pipe(
      fromKpi.getKpiDetailsByType(this.params.type),
      map((data: any) => data?.map((item: any) => new KpiDetails(item)))
    );
    this.summary$ = this.store.pipe(select(fromKpi.getSummary));
  }

  getClassNameByProgress(progress: number): string {
    return this.kpiUtils.getClassNameByProgress(progress);
  }

  showEmployeeDetail(eaEmployeeId: string, event: MouseEvent) {
    event.preventDefault();
    const queryParams = {
      type: this.params.type,
      from: this.params.from,
      to: this.params.to,
      offices: "", //this.params.offices,
      employees: eaEmployeeId,
    };

    this.router.navigate([], {
      queryParams,
      replaceUrl: true,
    });
  }
}
